/*! Genki Vital — Wunschliste (eigenständig, localStorage, ohne Drittanbieter)
   Bindet alle [data-gv-wish]-Buttons, pflegt localStorage 'gv_wish' und aktualisiert
   [data-gv-wish-count]-Zähler. Öffentliche API unter window.GVWish.
   Hinweis: Diese Datei kümmert sich NUR um die Wunschliste – der Warenkorb/Drawer
   wird komplett vom Theme verwaltet (kein Eingriff von hier). */
(function () {
  var KEY = 'gv_wish';

  function read() {
    var a;
    try { a = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    if (!Array.isArray(a)) return [];
    // Nur gültige Einträge (mit id) zählen – schützt vor Phantom-/Fremdeinträgen
    return a.filter(function (x) { return x && x.id !== undefined && x.id !== null && x.id !== ''; });
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('gv:wish:change', { detail: a }));
  }
  function has(id) { id = String(id); return read().some(function (x) { return String(x.id) === id; }); }
  function remove(id) { id = String(id); write(read().filter(function (x) { return String(x.id) !== id; })); }
  function add(item) { if (has(item.id)) return false; var a = read(); a.push(item); write(a); return true; }
  function toggle(item) { return has(item.id) ? (remove(item.id), false) : add(item); }
  function count() { return read().length; }

  function paint() {
    document.querySelectorAll('[data-gv-wish]').forEach(function (b) {
      var on = has(b.getAttribute('data-id'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-gv-wish-count]').forEach(function (c) {
      var n = count();
      c.textContent = n;
      if (n > 0) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
    });
  }

  // Klick auf ein Herz (Event-Delegation → funktioniert auch für nachgeladene Karten)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gv-wish]');
    if (!b) return;
    e.preventDefault();
    if (!b.getAttribute('data-id')) return;
    toggle({
      id: b.getAttribute('data-id'),
      handle: b.getAttribute('data-handle'),
      title: b.getAttribute('data-title'),
      url: b.getAttribute('data-url'),
      img: b.getAttribute('data-img'),
      price: b.getAttribute('data-price'),
      variant: b.getAttribute('data-variant'),
      multi: b.getAttribute('data-multi'),
      sku: b.getAttribute('data-sku')
    });
    paint();
  });

  // Geräteübergreifend in mehreren Tabs synchron halten + nach jeder Änderung neu zeichnen
  document.addEventListener('gv:wish:change', paint);
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });

  // Dynamisch nachgeladene Karten (z. B. „Vervollständige dein Set") neu zeichnen
  var t, mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(paint, 120); });
  function start() { paint(); if (document.body) mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }

  window.GVWish = { read: read, write: write, has: has, add: add, remove: remove, toggle: toggle, count: count, paint: paint };
})();
